/**
 * Principal risk LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { RouteOrder } from './routeOrder';
import { Pair } from './pair';

export interface ExecutionStatus {
  routeOrderId?: number;
  created?: string;
  accountId?: number;
  account?: Account;
  pairId?: number;
  pair?: Pair;
  takeProfitOrderId?: number;
  stopLossOrderId?: number;
  quantity?: number;
  volume?: number;
  execQuantity?: number;
  execVolume?: number;
  takeProfitPx?: number;
  stopLossPx?: number;
  forceCloseTime?: string;
  active?: boolean;
  takeProfitCanceling?: boolean;
  routeOrder?: RouteOrder;
}
